var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppNavigation'),_c('AppBar'),_c('v-main',[_c('v-container',{attrs:{"data-test":"mainLayout"}},[_c('v-slide-x-reverse-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('AppMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }